import * as React from 'react';

import {reduxForm} from 'redux-form';

// @ts-expect-error
import {ActivitiesCircleIcon} from 'shells/icon/svg/activities-circle-icon';
import {ReduxFormTextField} from 'shells/redux-form-fields/textfield';

import {ActivityTypeSelectField, EntitySelectField} from '../../core/form/fields';

import {DefaultFooter} from '../default-footer/default-footer';
import {ActivityTimesNew} from '../fields/activity-times-new';
import {FormWrapper} from '../form-wrapper/form-wrapper';

import {getFieldComponent} from './helpers';

import styles from '../form-common.module.css';

type Props = {
    handleSubmit: () => void;
    reset: () => void;
    submitting: boolean;
    submitFailed: boolean;
    onCancelClick: () => void;
};

const FORM_FIELDS = [
    {
        fieldKey: 'name',
        title: 'Name',
        name: 'name',
        type: 'string',
        isRequired: true,
        component: ReduxFormTextField,
    },
    {
        fieldKey: 'activityType',
        title: 'Activity type',
        placeholder: '',
        name: 'activityType',
        type: 'enum',
        component: ActivityTypeSelectField,
    },
    {
        fieldKey: 'activityTime',
        title: 'Activity time',
        placeholder: undefined,
        name: 'activityTime',
        type: 'string',
        isRequired: true,
        component: ActivityTimesNew,
    },
    {
        fieldKey: 'location',
        title: 'Location',
        name: 'location',
        type: 'location',
        component: ReduxFormTextField,
    },
    {
        fieldKey: 'links.participants',
        title: 'Participants',
        name: 'participants',
        type: 'relationship',
        component: EntitySelectField,
        isMulti: true,
    },
    {
        fieldKey: 'description',
        title: 'Agenda',
        name: 'description',
        type: 'text',
        component: ReduxFormTextField,
    },
];

const FIELD_COMPONENTS = FORM_FIELDS.map((field) =>
    getFieldComponent({
        // @ts-expect-error
        field,
        entityType: 'activities',
    })
);

function ActivityFormConnectedComponent(props: Props) {
    const handleCancelClick = () => {
        props.onCancelClick();
        props.reset();
    };

    const footer = (
        <DefaultFooter
            onCancel={handleCancelClick}
            isSaving={props.submitting}
            errorSaving={props.submitFailed}
            buttonText='Schedule activity'
            savingText='Scheduling activity…'
        />
    );

    return (
        <form onSubmit={props.handleSubmit} className={styles.form}>
            {/* @ts-expect-error */}
            <FormWrapper icon={ActivitiesCircleIcon} reset={props.reset} footer={footer}>
                {FIELD_COMPONENTS}
            </FormWrapper>
        </form>
    );
}

export const ActivityFormConnected = reduxForm({
    form: 'activities-modal',
    // @ts-expect-error
})(ActivityFormConnectedComponent);
